import styled from 'styled-components';
import media from '../../../styles/media.style';

import { BG_GRAY, NAVIGATION_DESKTOP_HEIGHT, WHITE } from '../../../styles/variables.style';

export const Logo = styled.img`
  width: 70%;
  height: auto;
`;

export const LogoutButton = styled.button`
  color: ${WHITE};
  margin-bottom: 0;
  text-transform: uppercase;
  text-decoration: underline;
  font-size: 13px;
  line-height: 1.54;
  letter-spacing: 0.2px;
  background: transparent;
  padding: 0;
  cursor: pointer;
  border: none;
  display: block;
  margin-top: 1em;
`;

export const LogoutButtonPlaceholder = styled.div`
  margin-top: 1em;
`;

export const LogoSection = styled.div`
  flex: 1;
`;

export const MainSection = styled.div`
  flex: 3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const SwitchButton = styled.button`
  color: ${WHITE};
  text-align: right;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.1px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin-left: 2em;
  text-transform: uppercase;
`;

export const SwitchSection = styled.div`
  margin-left: auto;
  border-left: 1px solid ${WHITE};
`;

export const UserLocation = styled.span`
  color: ${WHITE};
  font-size: 12px;
  letter-spacing: 0.2px;
`;

export const UserName = styled.span`
  color: ${WHITE};
  font-size: 12px;
  letter-spacing: 0.2px;
  border-right: 1px solid ${WHITE};
  padding-right: 10px;
  margin-right: 10px;
`;

export const Wrapper = styled.div`
  background: ${BG_GRAY.COMMON_8};
  height: ${NAVIGATION_DESKTOP_HEIGHT}px;
  padding: 0 5%;
  align-items: center;
  display: none;

  ${media.tabletP`
    display: flex;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/StylistHeader/TabletHeader/TabletHeader.style.js